import { path } from 'ramda'
import { shallowEqual, useSelector } from 'react-redux'

import applications from 'app/components/Subs/applications'
import * as apps from 'app/common/constants/services'


export const useFavorites = (studentID: string) => {
  const studentId = parseInt(studentID, 10)
  const fav: Record<string, boolean> = useSelector((state: any) => state.settings.fav, shallowEqual)
  const studentData = useSelector((state: any) => state.students.data[studentID], shallowEqual)

  const studentsWhoHasPolls = (useSelector(
    path(['apps', 'data', 'polls', 'students']),
    shallowEqual
  ) || []) as Array<number>

  return applications.filter((app) => {
    if (!studentData) return false
    if (app === apps.APP_CAFETERIA && !studentData.hasCafeteria) return false
    if (app === apps.APP_DNEVNIK && !studentData.hasDnevnik) return false
    if (app === apps.APP_POLLS && !studentsWhoHasPolls.includes(studentId)) return false

    return fav[app]
  })
}
